"use strict";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
import smoothscroll from "smoothscroll-polyfill";
// import * as accordion from "./common/_accordion";
import * as lock from "./common/_scrollLock";
gsap.registerPlugin(EaselPlugin, ScrollTrigger);

// header
document.querySelectorAll(".js-header-menu").forEach((target) => {
  target.addEventListener("click", () => {
    document.querySelector(".header").classList.toggle("is-active");
    lock.scrollLock();
  });
});

// accordion
// accordion.init();

const mediaQuery = matchMedia("screen and (min-width: 768px)");
changeMediaQuery(mediaQuery);
// ウィンドウサイズが変更されても実行されるように
mediaQuery.addListener(changeMediaQuery);

/**
 * ロードイベント登録
 */

document.addEventListener("DOMContentLoaded", () => {}, false);
window.addEventListener(
  "load",
  () => {
    document.querySelector("main").classList.add("loaded");

    let tabQuery = getQueryString("tab");
    if (tabQuery != "" && tabQuery != null) {
      console.log(tabQuery);
      document
        .querySelector('.tab-list__item--above[data-tab="' + tabQuery + '"]')
        .click();

      let targetElement = document.querySelector(".tab-list--above");
      let rectTop = targetElement.getBoundingClientRect().top;
      let offsetTop = window.pageYOffset;
      let top = rectTop + offsetTop;

      window.scrollTo({
        top,
        behavior: "smooth",
      });
    }

    let anchorQuery = getQueryString("anchor");
    if (anchorQuery != "" && anchorQuery != null) {
      let targetElement = document.querySelector("#" + anchorQuery);
      let rectTop = targetElement.getBoundingClientRect().top;
      let offsetTop = window.pageYOffset;
      let top = rectTop + offsetTop;

      window.scrollTo({
        top,
        behavior: "smooth",
      });
    }
  },
  false
);
function getQueryString(name) {
  var array = [];
  var url = window.location.search;

  var hash = url.slice(1).split("&");

  for (var i = 0; i < hash.length; i++) {
    array[hash[i].split("=")[0]] = hash[i].split("=")[1];
  }
  if (name in array == true) {
    return decodeURI(array[name]);
  } else {
    return null;
  }
}

/**
 * リサイズイベント登録
 */
window.addEventListener("resize", function () {}, false);

function changeMediaQuery(mq) {
  if (mq.matches) {
    // PC
    document.body.classList.add("is-pc");
    document.body.classList.remove("is-sp");
  } else {
    // SP
    document.body.classList.add("is-sp");
    document.body.classList.remove("is-pc");
    // kv
    // スクロールするとvhが変わってしまう問題を解決
    changeKvHeight();
    window.addEventListener("resize", changeKvHeight);
  }
}

function changeKvHeight() {
  document.querySelectorAll(".js-height").forEach((target) => {
    target.style.height = `${window.outerHeight}px`;
  });
}

// スムーススクロール
smoothscroll.polyfill();

document.querySelectorAll(`a[href*="#"]`).forEach((link) => {
  link.addEventListener("click", (e) => {
    const target = e.currentTarget;
    e.preventDefault();
    const targetId = target.hash;
    var href = target.href;
    var currentURL = location.href;
    if (currentURL.indexOf("#") > -1) currentURL = currentURL.split("#")[0];
    var param = href.substring(href.indexOf("?"));

    if (
      target.hasAttribute("target") &&
      target.getAttribute("target") == "_blank"
    ) {
      open(target.href, "_blank");
    } else {
      if (href.indexOf("?") > -1) {
        location.href = href.replace(param, "");
      } else {
        if (href.indexOf(currentURL) == -1 || location.pathname == "/") {
          location.href = href;
        } else if (href.indexOf(currentURL) > -1) {
          const targetElement = document.querySelector(targetId);
          // 画面上部から要素までの距離
          const rectTop = targetElement.getBoundingClientRect().top;
          // 現在のスクロール距離
          const offsetTop = window.pageYOffset;
          //スクロール位置に持たせるバッファ
          const top = rectTop + offsetTop;

          window.scrollTo({
            top,
            behavior: "smooth",
          });
        }
      }
    }
  });
});

// IEでスムーススクロールを無効に
if (document.documentMode) {
  document.querySelector(`body`).addEventListener("mousewheel", (event) => {
    event.preventDefault();
    let wd = event.wheelDelta;
    let csp = window.pageYOffset;
    window.scrollTo(0, csp - wd);
  });
}

setupVh();
function setupVh() {
  const mediaQuery = window.matchMedia("screen and (min-width: 768px)");
  mediaQuery.addEventListener("change", setVhProperty);

  setVhProperty();

  function setVhProperty() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }
}
setupVw();
function setupVw() {
  const mediaQuery = window.matchMedia("screen and (min-width: 768px)");
  mediaQuery.addEventListener("change", setVwProperty);

  setVwProperty();

  function setVwProperty() {
    const vw = document.body.clientWidth * 0.01;
    document.documentElement.style.setProperty("--vw", `${vw}px`);
  }
}

const fadein = document.querySelectorAll(".fadein");
fadein.forEach((item) => {
  ScrollTrigger.create({
    trigger: item,
    start: "top 75%",
    once: true,
    onEnter: () => {
      item.classList.add("on");
    },
  });
});

const anim = document.querySelectorAll(".anim");
anim.forEach((item) => {
  ScrollTrigger.create({
    trigger: item,
    start: "top 75%",
    once: true,
    onEnter: () => {
      item.classList.add("exit");
    },
  });
});

const animTitle = document.querySelectorAll(".stream-ttl");
animTitle.forEach((item) => {
  ScrollTrigger.create({
    trigger: item,
    start: "top 75%",
    once: true,
    onEnter: () => {
      item.classList.add("exit");
    },
  });
});

// // Accordion
const accordionBtn = document.querySelectorAll(".js-accordion");
for (let i = 0; i < accordionBtn.length; i++) {
  accordionBtn[i].addEventListener("click", function () {
    this.classList.toggle("is-active");
    const target = this.nextElementSibling;
    const result = target.classList.contains("is-open");
    if (result) {
      // 閉じる
      target.classList.remove("is-open");
      gsap.to(target, {
        height: 0,
        duration: 0.5,
        ease: "power2.inOut",
      });
    } else {
      // 開く
      target.classList.add("is-open");
      gsap.to(target, {
        height: "auto",
        duration: 0.5,
        ease: "power2.inOut",
      });
    }
  });
}
